import { Option } from "./Option";

const YesNo = (props: {
  value: string | string[];
  onChange: (value: string) => void;
}) => {
  return (
    <>
      <div className="flex gap-3">
        <Option
          name="Yes"
          value="Yes"
          checked={props.value === "Yes"}
          onChange={(e) => props.onChange("Yes")}
        />
        <Option
          name="No"
          value="No"
          checked={props.value === "No"}
          onChange={(e) => props.onChange("No")}
        />
      </div>
    </>
  );
};
export default YesNo;
